<script lang="ts">
	import { goto } from '$app/navigation';
	import { _ } from 'svelte-i18n';

	export let as: 'link' | 'button' = 'button';
	export let target: '_self' | '_blank' | '_parent' | '_top' = '_self';
	export let linkTo: string;
	let className;
	export { className as class };
	export let label = '';
</script>

{#if as === 'button'}
	<button
		class={`read-more ${className || ''}`}
		type="button"
		on:click={() => {
			goto(linkTo);
		}}>{`${$_('news.readMore')}`}</button
	>
{:else}
	<a href={linkTo} {target} class={`read-more ${className || ''}`}
		>{`${$_('news.readMore')}`}<span class="invisible">{` about ${label}`}</span></a
	>
{/if}

<style lang="scss">
	@import 'readMore';
</style>
